import React, { useEffect, useState } from 'react';
import { Avatar, Box, Chip, Stack, Typography } from '@mui/material';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import '../assets/sass/carousels.scss';
import palette from '../assets/sass/palette.scss';
import GameScoringStrokePlay from './GameScoringStrokePlay';
import GameScoringMatchPlay from './GameScoringMatchPlay';
import MatchViewOnly from './MatchViewOnly';
const Winner = ({ winner }) => {
  return (
    <Box
      sx={{
        position: 'absolute',
        top: -12,
        right: -12,
        width: '37.5px',
        height: '36px',
        zIndex: 2,
        pointerEvents: 'none',
      }}
    >
      <svg
        width="37.5"
        height="36"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="12"
          cy="12"
          r="11"
          transform="matrix(-1 0 0 1 24.9707 0)"
          fill="#C8B359"
          stroke="white"
          strokeWidth="2"
        />
        <path
          d="M8.06967 9.05582H9.04924C9.02203 8.81093 9.02203 8.6522 9.02203 8.62499V8.1488H7.78849C7.58895 8.1488 7.39848 8.23497 7.27149 8.38916C7.13998 8.54789 7.08555 8.74743 7.12184 8.94698C7.27603 9.79957 7.96536 12.3846 10.573 12.8789C10.2601 12.4707 10.0152 12.058 9.81567 11.6544C8.70458 11.0286 8.25107 9.82678 8.06967 9.05582Z"
          fill="white"
        />
        <path
          d="M18.6398 8.38916C18.5128 8.23497 18.3223 8.1488 18.1228 8.1488H16.8892V8.62499C16.8892 8.65673 16.8892 8.81093 16.862 9.05582H17.8416C17.6647 9.82678 17.2067 11.0331 16.1001 11.6544C15.9006 12.058 15.6557 12.4707 15.3428 12.8789C17.9504 12.3846 18.6398 9.79504 18.794 8.94244C18.8303 8.7429 18.7758 8.53882 18.6443 8.38463L18.6398 8.38916Z"
          fill="white"
        />
        <path d="M15.1934 16.9883H10.7173V17.8953H15.1934V16.9883Z" fill="white" />
        <path
          d="M15.979 8.62544V7.81366H9.9292V8.62544C9.9292 8.75242 9.97908 11.6005 12.5097 13.5369V16.0902H13.3985V13.5369C15.9291 11.6005 15.979 8.75242 15.979 8.62544Z"
          fill="white"
        />
      </svg>
    </Box>
  );
};
const GameMatcheCarousel = ({ gameData, users, isOrganizer }) => {
  const filteredMatches = gameData.matches;
  // const filteredMatches = gameData.matches.filter((match) => match.status === 'completed');
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 1,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  const [matchSlotPlayers, setMatchSlotPlayers] = useState({});

  useEffect(() => {
    const initialSlotPlayers = {};
    gameData.matches.forEach((match, index) => {
      if (match.players) {
        initialSlotPlayers[index + 1] = match.players.map((player) => ({
          user: player.uid || player.user || player.userId,
          userName: player.userName,
          group: player.group,
          handicap: player.handicap || 0,
        }));
      }
    });
    setMatchSlotPlayers(initialSlotPlayers);
  }, [gameData]);


  const getUserPhotoURL = (player) => {
    const uid = player?.uid || player?.user;
    const user = users?.find((user) => user?.uid === uid || user?.user === uid);
    return user ? user?.photoURL : null;
  };

  const getUserInitial = (player) => {
    const userName = player.userName || player.username || '';
    return userName.charAt(0)?.toUpperCase() || '';
  };




  // eslint-disable-next-line no-unused-vars
  const Player = ({ player, showBorder, winner, index = 0 }) => {
    const userPhotoUrl = getUserPhotoURL(player);
    return (
      <Stack
        direction="column"
        sx={{
          width: '100%',
          alignItems: 'center',
          mb: 2,
          borderRight: showBorder ? `1px solid ${palette.borderPink}` : 'none',
        }}
      >
        {userPhotoUrl ? (
          <Box sx={{ position: 'relative' }}>
            <Avatar
              alt=""
              sx={{
                bgcolor: (index || 0) % 2 === 0 ? '#E9FFEA' : '#F9EDFF',
                width: '48px',
                height: '50px',
              }}
              src={userPhotoUrl}
            />
            {winner && <Winner winner={winner} />}
          </Box>
        ) : (
          <Box sx={{ position: 'relative' }}>
            <Box
              alt=""
              sx={{
                bgcolor: (index || 0) % 2 === 0 ? '#E9FFEA' : '#F9EDFF',
                width: '48px',
                height: '50px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: '50%',
              }}
            >
              <Typography
                variant="factorA"
                color="primary"
                component="small"
                sx={{ color: '#4C4C4C' }}
              >
                {getUserInitial(player)}
              </Typography>
            </Box>
            {winner && <Winner winner={winner} />}
          </Box>
        )}
        <Box sx={{ textAlign: 'center' }}>
          <Typography variant="body1" component="p" sx={{ fontWeight: 700 }}>
            {player.userName || player.username || ''}
          </Typography>
          <Chip label={player?.waglRating?.toFixed(0) || 50} variant="rankChip" />
        </Box>
      </Stack>
    );
  };

  return (
    <Box sx={{ width: '100%', pt: 3, pb: 4 }}>
      <Carousel
        responsive={responsive}
        showDots={true}
        keyBoardControl={true}
        customTransition="all .5"
        transitionDuration={500}
        partialVisible
        arrows={false}
        renderDotsOutside={true}
        swipeable
        slidesToSlide={1}
        autoPlay
        autoPlaySpeed={3000}
        rewind
        infinite
      >
        {filteredMatches.map((match, index) => {
          if (match.status !== 'completed') {
            return (
              <Box key={index}>
                <MatchViewOnly
                  gameData={gameData}
                  users={users}
                  isOrganiser={isOrganizer}
                  matchNumber={index + 1}
                  allSelectedPlayers={match.players}
                  onSlotPlayersChange={() => {}}
                  onFinalise={() => {}}
                  viewOnly={true}
                />
              </Box>
            );
          }
          return (
            <Box key={`match-${index}`}>
              {match.format === 'stroke' && (
                <GameScoringStrokePlay
                  game={gameData}
                  onFinalise={() => {}}
                  users={users}
                  isOrganiser={false}
                  matchNumber={index + 1}
                  slotPlayers={matchSlotPlayers[index + 1]}
                  teaTime={match.teaTime}
                  handleFinalise={() => {}}
                  status={match.status}
                  matchGroupingType={false}
                  match={match}
                  viewOnly={true}
                ></GameScoringStrokePlay>
              )}
              {match.format === 'match' && (
                <GameScoringMatchPlay
                  game={gameData}
                  slotPlayers={matchSlotPlayers[index + 1]}
                  onFinalise={() => {}}
                  users={users}
                  isOrganiser={false}
                  alreadyScored={match.status === 'completed'}
                  matchNumber={index + 1}
                  matchGroupingType={match.matchGroupingType || ''}
                  teaTime={match.teaTime}
                  match={match}
                  viewOnly={true}
                ></GameScoringMatchPlay>
              )}
            </Box>
          );
        })}
      </Carousel>
    </Box>
  );
};

export default GameMatcheCarousel;
